<section class="product-how-it-works" [attr.aria-labelledby]="resolvedHeadingId">
  <div class="product-how-it-works__content">
    <h2 class="product-how-it-works__title" [id]="resolvedHeadingId">{{ headline }}</h2>

    <div *ngIf="hasTabs" class="product-how-it-works__tabs">
      <c11n-tabs
        [activeItem]="activeTab?.id || ''"
        [ariaLabel]="headline"
        (activeItemChange)="onTabChange($event)"
        variant="left-aligned"
      >
        <ng-container *ngFor="let tab of tabs; trackBy: trackByTabId">
          <c11n-tab-panel [id]="tab.id" [labelText]="tab.label"></c11n-tab-panel>
        </ng-container>
      </c11n-tabs>

      <div class="product-how-it-works__cards" *ngIf="activeTab">
        <c11n-card
          *ngFor="let card of activeTab.cards; trackBy: trackByCardIndex"
          class="product-how-it-works__card"
          density="small"
          [hasImage]="true"
          [imagePosition]="'above'"
          imageAspectRatio="4-3"
          [imagePadding]="false"
        >
          <img
            cardImage
            class="product-how-it-works__card-image"
            [src]="card.imageSrc"
            [alt]="card.imageAlt"
          />
          <h3 cardHeading class="product-how-it-works__card-title">{{ card.title }}</h3>
          <p cardBody class="product-how-it-works__card-description" [innerHTML]="card.description"></p>
        </c11n-card>
      </div>
    </div>
  </div>
</section>
